import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "dashboard-home",
        path: "/dashboard/",
        component: () => import("./components/index.vue"),
        children: [
            {
                name: "dashboard",
                path: "/dashboard/:curDashboardCode",
                component: () => import("./components/dashboard.vue"),
                props: true
            },
        ],
    },
    {
        name: "dashboard-manage",
        path: "/dashboard-manage/",
        component: () => import("./components/index.vue"),
        props: true,
        children: [
            {
                name: "dashboard-manage-selected",
                path: "/dashboard-manage/:curDashboardCode",
                component: () => import("./components/dashboard.vue"),
                props: true,
            },
        ]
    },
    {
        name: "dashboard-widget",
        path: "/dashboard/widget/:widgetCode",
        component: () => import("./components/widget/WidgetTileContainer.vue"),
        props: true
    },
];

export default routes;
